import styled from 'styled-components';

import {
  BodySmallMedium,
  BodySmallRegular,
  BodyXSmallRegular,
  Colour,
  TextEllipsis,
} from '@xemplo/style-constants';

export const CellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
  padding-right: 0;

  text-align: left;
  ${TextEllipsis};

  > svg {
    margin-left: 8px;
  }

  span,
  div {
    ${TextEllipsis};
  }
`;

export const CellContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: row;
  ${TextEllipsis};
`;

export const Name = styled.span`
  ${BodySmallMedium};
  color: ${Colour.Gray[700]};
`;

export const Email = styled.span`
  ${BodyXSmallRegular};
  color: ${Colour.Gray[500]};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${TextEllipsis};
`;

export const CellText = styled.span`
  ${BodySmallRegular};
  color: ${Colour.Gray[600]};
`;
